module.exports = __webpack_public_path__ + "img/g5.d36ef3e1.jpg";